import styled from 'styled-components';

export const UiAlert = styled.div`
	display: block;
`;